import * as React from "react";
import { styled } from "@mui/material/styles";
import { Link, Typography } from "@mui/material";
import { tutorialLinks } from "./tutorialLinks";
import { KeyValue } from "../../../interfaces";
const PREFIX = "Tutorials";

const classes = {
  ul: `${PREFIX}-ul`,
  list: `${PREFIX}-list`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.ul}`]: { marginTop: 0 },

  [`& .${classes.list}`]: {
    "color": theme.palette.primary.main,
    "lineHeight": "1.5rem",
    "& .MuiTypography-body2": {
      paddingBottom: 4,
    },
  },
}));

export default function Tutorials({ title }: { title?: React.JSX.Element }) {
  const baseDownloadUrl =
    "https://s3-us-gov-west-1.amazonaws.com/cg-2e5c99a6-e282-42bf-9844-35f5430338a5/downloads/";
  return (
    <Root>
      {title}
      <Typography variant="body2" color="primary.main">
        Tutorial topics have been organized by their BankFind Suite usage to
        aide in locating relevant content.
      </Typography>
      {tutorialLinks.map((topic: KeyValue) => {
        return (
          <React.Fragment key={topic.header}>
            <Typography variant="h3" style={{ paddingBottom: 0 }}>
              {topic.header}
            </Typography>
            <ul className={classes.ul}>
              {topic.links.map((link: KeyValue) => {
                return (
                  <li className={classes.list} key={link.title}>
                    <Typography variant="body2">
                      <Link
                        href={
                          link.directLink
                            ? link.fileName
                            : `${baseDownloadUrl}${link.fileName}`
                        }
                        target={link.download ? "" : "_blank"}
                        rel="noopener"
                      >
                        {link.title}
                      </Link>
                    </Typography>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      })}
    </Root>
  );
}
